var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPlusDeepBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20302 4.01166H6.01901V1.82965C6.01901 1.12665 5.44902 0.556641 4.74602 0.556641C4.04502 0.556641 3.47502 1.12665 3.47502 1.82965V4.01166H1.29102C0.590016 4.01166 0.0200195 4.58165 0.0200195 5.28265C0.0200195 5.98565 0.590016 6.55566 1.29102 6.55566H3.47502V8.73965C3.47502 9.44065 4.04502 10.0117 4.74602 10.0117C5.44902 10.0117 6.01901 9.44165 6.01901 8.73965V6.55566H8.20302C8.90402 6.55566 9.47401 5.98565 9.47401 5.28265C9.47501 4.58165 8.90502 4.01166 8.20302 4.01166Z",
    fill: "#2E7EFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPlusDeepBlue);
export default __webpack_public_path__ + "static/media/email-plus-deep-blue.fc2e6276f9e20be3cd96b14c4dfd3064.svg";
export { ForwardRef as ReactComponent };